import Col from "react-bootstrap/Col";
import {BrowserView, MobileView} from "react-device-detect";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse";
import React, {useEffect, useState} from "react";
import {useEventProvider} from "../../../providers/EventProvider.tsx";
import {useStoreMessages} from '../../../store/useStoreMessages.ts'
import {useStoreBanners} from '../../../store/useStoreBanners.ts'

export const Message = () => {
    const [open, setOpen] = useState<boolean>(false);
    const [message, setMessage] = useState<string|null>(null);
    const [title, setTitle] = useState<string | null>(null)
    const [titleIcon, setTitleIcon] = useState<string | null>(null)
    const [titleIconColor, setTitleIconColor] = useState<string | null>(null)
    const [titleTextColor, setTitleTextColor] = useState<string | null>(null)
    const [border, setBorder] = useState<string | null>(null)
    const {newMessages} = useEventProvider();
    const fetchMessages = useStoreMessages((state) => state.fetch);
    const loaded = useStoreMessages((state) => state.loaded);
    const setLoaded = useStoreMessages((state) => state.setLoaded);
    const messageInformation = useStoreMessages((state) => state.messageInformation);
    const messageAlert = useStoreMessages((state) => state.messageAlert);
    const bannersLeft = useStoreBanners((state) => state.bannersLeft)

    useEffect(() => {
        fetchMessages()
        initializeMessageBlock();
    }, [loaded]);

    useEffect(() => {
        if (newMessages.data) {
            setLoaded(false);
            delete newMessages.data;
        }
    }, [newMessages]);

    function initializeMessageBlock() {
        if (messageInformation && bannersLeft.length === 0) {
            setMessage(messageInformation)
            setTitle('Informations');
            setTitleIcon('info-circle');
            setTitleIconColor('info');
            setTitleTextColor('text-info');
            setBorder('border border-info border-top-0');
        }

        if (messageAlert) {
            setMessage(messageAlert)
            setTitle('Alertes');
            setTitleIcon('exclamation-triangle');
            setTitleIconColor('red');
            setTitleTextColor('text-danger');
            setBorder('border border-danger border-top-0');
        }
    }

    return (
        <>
            {message?.id && (
                <Col md={{span: 12}} lg={{span: 6}} className={`info bg-grey p-3 order-sm-first order-last ${border}`}>
                    <BrowserView renderWithFragment={true}>
                        <div className="title d-flex align-items-center mb-2">
                            <FontAwesomeIcon
                                icon={['fas', titleIcon]}
                                color={`var(--${titleIconColor})`}
                                className="mr-1"
                                size="lg"
                            />
                            <h2 className={`mb-0 ${titleTextColor}`}>{title}</h2>
                        </div>
                        {message && (
                            <div
                                className="content mb-0 text-wrap"
                                dangerouslySetInnerHTML={{__html: message.content}}>
                            </div>
                        )}
                    </BrowserView>

                    <MobileView renderWithFragment={true}>
                        <div className="title d-flex align-items-center align-content-center">
                            <FontAwesomeIcon
                                icon={['fas', titleIcon]}
                                color={`var(--${titleIconColor})`}
                                className="mr-1"
                                size="lg"
                            />
                            <h2 className="d-flex justify-content-between mb-0 w-100">
                                <span>{title}</span>
                                <Button
                                    onClick={() => setOpen(!open)}
                                    aria-controls="info-collapse-text"
                                    aria-expanded={open}
                                    className={"btn-sm float-end"}
                                >
                                    Voir
                                </Button>
                            </h2>
                        </div>

                        <Collapse in={open}>
                            <div id="info-collapse-text">
                                {/* {!isLoading && message && ( */}
                                {message && (
                                    <div
                                        className="content mb-0 text-wrap"
                                        dangerouslySetInnerHTML={{__html: message.content}}></div>
                                )}
                            </div>
                        </Collapse>
                    </MobileView>
                </Col>
            )}
        </>
    );
}